import { date } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const dateSchema = date().label('Number');

export const DateHookFormField = (props: FieldInputProps) => <HookFormField.Input label="Date" type="date" {...props}/>;